"use client";

import { ColorOrKey } from "@faire/web--source/slate/Color";
import * as React from "react";
import { LinkProps as RouterLinkProps } from "react-router-dom";
import styled from "styled-components";

import { Link } from "../LinkAnchor";

import {
  ILinkProps,
  onClickTextAction,
  TextAction,
  ITextActionProps,
} from "./common";

const StyledLink = styled(Link)`
  display: inline-block;
  width: fit-content;
` as any; // This element is being uncooperative

interface ITextLinkProps
  extends ILinkProps,
    Omit<ITextActionProps, "disabled">,
    RouterLinkProps {
  color?: ColorOrKey;
}

/**
 * @deprecated use EmbeddedLink from faire/web/ui/EmbeddedLink for text inside of Typography,
 *             or a Button with variant="tertiary" from @faire/web--source/slate/Button otherwise.
 * @supersededBy "@faire/web--source/slate/Button/Button#Button"
 * @trackcomponent
 */
export const TextLink: React.FC<ITextLinkProps> = ({
  postEventButtonId,
  onClick,
  icon,
  animate,
  color,
  hoverColor,
  children,
  typographyStyles,
  ...props
}) => (
  <StyledLink
    onClick={onClickTextAction(onClick, postEventButtonId)}
    {...props}
  >
    <TextAction
      animate={animate}
      color={color}
      hoverColor={hoverColor}
      icon={icon}
      typographyStyles={typographyStyles}
    >
      {children}
    </TextAction>
  </StyledLink>
);
